export default __webpack_public_path__ + "static/media/triangle-error.1914eb77.svg";